import { TRANSFER } from '../../models/transfer';
import { intersection } from '../../../common/utils/intersection';
import { SERVICES } from '../../../constants';
import { isGateServiceDisabled } from '../../../common/utils/is-gate-service-disabled';

const isLateBookingServiceEnabled = (transfer, secondTransfer, service) => {
    const isFirstTransferLate = transfer.extras[service];
    const isSecondTransferLate = secondTransfer && secondTransfer.extras[service];

    return Boolean(isFirstTransferLate || isSecondTransferLate);
};

export const isServiceAvailableHelper = (service, transfer, secondTransfer) => {
    const transferTypes = [transfer.typeId, secondTransfer && secondTransfer.typeId];
    const isToAirport = intersection([TRANSFER.TO_MUNICH, TRANSFER.TO_NUREMBERG], transferTypes).length > 0;
    const isFromAirport = intersection([TRANSFER.FROM_MUNICH, TRANSFER.FROM_NUREMBERG], transferTypes).length > 0;

    switch (service.internalCode) {
        case 'FC':
            return isToAirport || isFromAirport;
        case 'ARRIVE_EARLY':
        case 'ARRIVE_LATE':
            return isToAirport;
        case 'GATE':
            return isFromAirport && !isGateServiceDisabled(transfer, secondTransfer);
        case SERVICES.LATE_TO_MUNICH:
            return isLateBookingServiceEnabled(transfer, secondTransfer, SERVICES.LATE_TO_MUNICH);
        case SERVICES.LATE_FROM_MUNICH:
            return isLateBookingServiceEnabled(transfer, secondTransfer, SERVICES.LATE_FROM_MUNICH);
        case SERVICES.LATE:
            return isLateBookingServiceEnabled(transfer, secondTransfer, SERVICES.LATE);
        default:
            return false;
    }
};
